/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Igdbrating2Inputs */

const id_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat IGDB`)
};

const ms_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian IGDB`)
};

const da_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Bedømmelse`)
};

const de_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-Bewertung`)
};

const en_us2_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Rating`)
};

const es_es2_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación IGDB`)
};

const es_mx2_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación IGDB`)
};

const fil_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng IGDB`)
};

const fr_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note IGDB`)
};

const it_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione IGDB`)
};

const hu_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB értékelés`)
};

const nl_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-beoordeling`)
};

const no_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-vurdering`)
};

const pl_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena IGDB`)
};

const pt_br2_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação IGDB`)
};

const pt_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação IGDB`)
};

const ro_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare IGDB`)
};

const fi_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-arvio`)
};

const sv_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB-betyg`)
};

const vi_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng IGDB`)
};

const tr_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Puanı`)
};

const cs_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení IGDB`)
};

const bg_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB оценка`)
};

const ru_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг IGDB`)
};

const uk_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг IGDB`)
};

const ar_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييم IGDB`)
};

const hi_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB रेटिंग`)
};

const th_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน IGDB`)
};

const ja_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB レーティング`)
};

const zh_cn2_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB评分`)
};

const zh_hant1_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB評分`)
};

const ko_offerdetail_overview_igdbrating2 = /** @type {(inputs: Offerdetail_Overview_Igdbrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB 평점`)
};

/**
* | output |
* | --- |
* | "IGDB Rating" |
*
* @param {Offerdetail_Overview_Igdbrating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_igdbrating2 = /** @type {((inputs?: Offerdetail_Overview_Igdbrating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Igdbrating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_igdbrating2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_igdbrating2(inputs)
	if (locale === "da") return da_offerdetail_overview_igdbrating2(inputs)
	if (locale === "de") return de_offerdetail_overview_igdbrating2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_igdbrating2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_igdbrating2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_igdbrating2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_igdbrating2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_igdbrating2(inputs)
	if (locale === "it") return it_offerdetail_overview_igdbrating2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_igdbrating2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_igdbrating2(inputs)
	if (locale === "no") return no_offerdetail_overview_igdbrating2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_igdbrating2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_igdbrating2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_igdbrating2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_igdbrating2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_igdbrating2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_igdbrating2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_igdbrating2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_igdbrating2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_igdbrating2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_igdbrating2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_igdbrating2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_igdbrating2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_igdbrating2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_igdbrating2(inputs)
	if (locale === "th") return th_offerdetail_overview_igdbrating2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_igdbrating2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_igdbrating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_igdbrating2(inputs)
	return ko_offerdetail_overview_igdbrating2(inputs)
});
export { offerdetail_overview_igdbrating2 as "offerDetail.overview.igdbRating" }